import startsWith from 'lodash/startsWith';

import { FetchArchiAppsSortTypes } from './archiAppsTypes';

import { ArchiAppPath } from './ArchiAppPath';

import { words } from '../../locales/keys';

export enum ArchiAppsPermissions {
  READ_ARCHI_APPS_INDEX_PAGE = 'read_archi_apps_index_page',
  READ_ARCHI_APP_SHOW_PAGE = 'read_archi_app_show_page',
  READ_DELETE_ARCHI_APP_BUTTON = 'read_delete_archi_app_button',
  READ_UPDATE_ARCHI_APP_BUTTON = 'read_update_archi_app_button',
  READ_CREATE_ARCHI_APP_BUTTON = 'read_create_archi_app_button',
  READ_ARCHI_APPS_AI_STUDIO_PAGE = 'read_archi_apps_ai_studio_page',
  READ_ARCHI_APPS_EDIT_AI_STUDIO_PAGE = 'read_archi_apps_edit_ai_studio_page'
}

export const INITIAL_ARCHI_APPS_FILTERS = {};
export const INITIAL_ARCHI_APPS_PAGE = 1;
export const INITIAL_ARCHI_APPS_SORT = [
  FetchArchiAppsSortTypes.CREATED_AT_DESC
];
export const INITIAL_ARCHI_APPS_LIMIT = 50;

export const enum AiStudioSecondaryMenuItems {
  AI_STUDIO = 'ai-studio',
  EDIT_AI_STUDIO = 'edit-ai-studio'
}

export const aiStudioMenuLinks = [
  {
    name: AiStudioSecondaryMenuItems.AI_STUDIO,
    href: ArchiAppPath.aiStudio(),
    i18nText: words.show,
    activeTest: (pathname: string) =>
      startsWith(pathname, ArchiAppPath.aiStudio()),
    permissions: [ArchiAppsPermissions.READ_ARCHI_APPS_EDIT_AI_STUDIO_PAGE]
  },
  {
    name: AiStudioSecondaryMenuItems.EDIT_AI_STUDIO,
    href: ArchiAppPath.editAiStudio(),
    i18nText: words.edit,
    permissions: [ArchiAppsPermissions.READ_ARCHI_APPS_EDIT_AI_STUDIO_PAGE]
  }
];
